import React, { useState } from "react";
import {
  DownloadSampleIcon,
  Downloadopt,
  Filteropt,
  LineIcon,
  LineSymbol,
  LinesIcon,
  Refreshopt,
  RightArrow,
  Searchopt,
} from "../../../../../utility/constants/assetsManager";
import { CustomInput } from "../../../../components/main_comps/custom_input/CustomInput";
import CustomTable from "../../../../components/main_comps/custom_table";
import { setHeaders } from "../../../../../services/aclValidateServiceTable";
import { VanFinanceHeaders } from "../../../../../utility/TableHeaders";
import MainComponent from "../../../../components/ui_comps/MainComponent";
import FilterComponent from "../../../../components/ui_comps/FilterComponent";

const VanFinanceIndex = () => {
  const [filter, setFilter] = useState(false);
  const inputStyle = {
    backgroundColor: "#F3F3F3",
    fontWeight: "400",
    fontSize: "14px",
    color: "#6C6B6B",
  };
  const containerStyle = {
    height: "20px",
    width: "300px",
    border: "none",
  };
  return (
    <div
      style={{
        marginLeft: "20px",
        overflow: "auto",
        boxSizing: "border-box",
        width: "100%",
      }}
    >
      <MainComponent
        headerTitle="Finance center"
        notificationRequired={false}
        filterRequired={false}
      />

      <div style={styles.maindiv}>
        <div style={styles.upperdiv}>
          <div>
            <Refreshopt style={styles.image} />
            <Filteropt
              style={styles.image}
              onClick={() => {
                setFilter(!filter);
              }}
            />
            <Downloadopt style={styles.image} />
          </div>

          <div style={styles.searchdiv}>
            <Searchopt style={styles.image} />
            <CustomInput
              placeholder="Search by client name,Txn id, Status"
              inputcomponentStyles={{ ...inputStyle }}
              inputStyles={{
                ...containerStyle,
              }}
            />
          </div>
        </div>
        {filter && (
          <>
            <FilterComponent
              filters={[
                { name: "searching", type: "searchAction" },
                { name: "date", type: "dateRange" },
                { name: "Customer Name", type: "search" },
                { name: "VAN", type: "search" },
                { name: "Business", type: "search" },
                { name: "Status", type: "search" },
              ]}
            />
          </>
        )}

        <div style={styles.tablestyle}>
          <CustomTable headers={setHeaders(VanFinanceHeaders)} />
        </div>
      </div>
    </div>
  );
};

const styles = {
  upperdiv: {
    height: "52px",
    background: "#F7F9FB",
    alignItems: "center",

    display: "flex",
    justifyContent: "space-between",
    //paddingTop: "5px",
    paddingRight: "20px",
    //border: "1px solid red",
    marginBottom:"20px"
  },
  image: {
    height: "20px",
    width: "20px",
    margin: "10px",
  },
  image2: {
    height: "20px",
    width: "20px",
  },
  searchdiv: {
    width: "360px",
    height: "32px",

    display: "flex",
    alignItems: "center",

    background: "#FFFFFF",
    border: "1px solid rgba(105, 105, 105, 0.3)",
    borderRadius: "6px",
  },
  maindiv: {
    backgroundColor: "#FFFFFF",

    paddingTop: "20px",
    //paddingBottom: "10px",
    paddingLeft:"20px",
    paddingRight:"20px"

    //marginTop: "2%",
  },
  tablestyle: {
    // marginTop: "20px",
    overflow: "hidden",
  },
};

export default VanFinanceIndex;
